<template>
  <v-breadcrumbs  small class="p-0 me-3 orange--text">
    <!-- <template v-slot:divider>
      <v-icon>mdi-chevron-double-right</v-icon>
    </template>
    <template v-slot:item="{ item }">
      <v-breadcrumbs-item :href="item.href">
        <v-icon>{{ item.icon }}</v-icon
        >{{ item.text }}
      </v-breadcrumbs-item>
    </template> -->
  </v-breadcrumbs>
</template>

<script>
import router from "../../router/index";
export default {
  name: "BreadCrumb",
  data: () => {
    return {
      routes: router.options.routes[3].children,
      breadCrumbsData: [
        {
          text: "",
          href: "/home",
          icon: "mdi-home",
        },
      ],
    };
  },
  props: {
    breadCrumbs: {
      type: Array,
    },
    title: {
      type: String,
    },
  },
  mounted() {
    this.getBreadCrumb(this.breadCrumbs);
  },
  methods: {
    getBreadCrumb(newVal) {
      // for (let val in newVal) {
      //   this.routes.map((route) => {
      //     if (route.name === newVal[val]) {
      //       this.breadCrumbsData.push({
      //         text: route.name,
      //         href: route.path,
      //       });
      //     }
      //   });
      // }

      console.log(newVal)
      console.log("data", this.breadCrumbsData);
    },
  },
  watch: {},
};
</script>
